const REGISTRATION_METHOD_TICKETS = 'tickets';
const REGISTRATION_METHOD_RSVP = 'collect';

export { REGISTRATION_METHOD_TICKETS, REGISTRATION_METHOD_RSVP };
